<script lang="ts">
    import { onMount } from 'svelte'
    import CheckoutForm from './checkout-form.svelte'
    import { decodeUuidBase58FromLink } from '../uuid-link-code'

    let referenceId: string = undefined
    let paymentLinkId: string = undefined

    let loaded = false

    async function detectParams() {
        // Só o link de pagamento entra por url. O 'g' (gatewayId) que existia aqui abria o checkout
        // sem link nenhum, e nessa forma era o próprio pagador quem digitava valor e descrição —
        // ele escolhia quanto pagar. Nenhuma url do produto era gerada assim: veio de um lote de
        // parâmetros de 2023 ('g', 'c', 'r', 'u') do qual 'c' e 'u' já haviam sido removidos.
        // os dois chegam em base58 (ver urlDoCheckout em payments-emit.svelte); link antigo, com uuid
        // cru, continua valendo — o decode devolve intacto o que já tem cara de uuid
        paymentLinkId = decodeUuidBase58FromLink(new URLSearchParams(window.location.search)?.get('id')) || undefined
        referenceId = decodeUuidBase58FromLink(new URLSearchParams(window.location.search)?.get('r')) || undefined
        loaded = true
    }

    onMount(async () => {
        await detectParams()
    })

    let gateway = null
    function showIssuer(ev) {
        gateway = ev.detail
    }
</script>

{#if loaded}
    <div class="page-checkout">
        <div class="page-checkout-bar" />
        <div class="checkout-container">
            <div class="company-info">
                <div>
                    <div class="checkout-business">{gateway?.issuerBusinessName || ''}</div>
                    <div class="checkout-legal">{gateway?.issuerLegalName || ''}</div>
                    <div class="checkout-document">Documento: {gateway?.issuerDocument || ''}</div>
                </div>
                <div>
                    <div class="checkout-address">Endereço: {gateway?.issuerAddress || ''}</div>
                    <div class="checkout-phone">
                        Telefone: {window.api.utils.utils.phoneFriendly(gateway?.issuerPhone) || ''}
                    </div>
                    <div class="checkout-email">E-mail do financeiro: {gateway?.issuerEmail || ''}</div>
                </div>
            </div>
            <CheckoutForm {referenceId} {paymentLinkId} on:load={showIssuer} />
            <div class="seals">
                <div class="seal">
                    <img src="/img/seal_aws.png" alt="" />
                </div>
                <div class="seal">
                    <img src="/img/seal_cloudflare.png" alt="" />
                </div>
                <div class="seal">
                    <img src="/img/seal_card_token.png" alt="" />
                </div>
                <div class="seal">
                    <img src="/img/seal_pci.png" alt="" />
                </div>
                <div class="seal">
                    <img src="/img/seal_https.png" alt="" />
                </div>
            </div>
            <div class="secure-footer">
                Você está em um ambiente extremamente seguro.
                <br />
                Nossos servidores estão protegidos na maior fornecedora de Cloud Computing do mundo - Amazon AWS
                <br />
                A rota até nossos servidores está protegida pela maior rede de CDN e proteção do mundo - Cloudflare
                <br />
                Os dados de cartão são tokenizados. Não armazenamos as informações do cartão diretamente - Card Tokenization
                <br />
                Todos os nossos processadores de pagamento estão em conformidade com o padrão de mercado - PCI DSS Compliant
                <br />
                Todos os dados são protegidos com criptografia de ponta a ponta - HTTPS over TLS
                <br />
            </div>
        </div>
    </div>
{/if}
